import React from 'react';
import tw, { styled } from 'twin.macro';

const TableWrapper = styled.div`
  ${tw`overflow-x-auto`}
`;

const Table = styled.table`
  ${tw`border-gray-300 border border-solid bg-transparent w-full my-4`}
  overflow-x: auto;
  border-collapse: collapse;
`;


const MarkdownTable = (props) => (
  <TableWrapper>
    <Table
      {...props}
    />
  </TableWrapper>
);

export default MarkdownTable;